import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { MediaService } from '../../../services/MediaService';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

/*
Ce composant permet d'afficher la liste des média correspondant à ce profil
et d'en ajouter.

*/
interface State {
    // Media: ReqType.Media[];
    nouveauMedia: File | null;
    description: string;
    nom: string;
    listeevent: ReqType.Event[];
    probleme: boolean;
    messageprobleme: string;
    redirect: boolean;
    mediaRedirect: number;
}

export interface Props {
    media: ReqType.Media[]; // Array<string>
    setMedia: (m: ReqType.Media[]) => void;
    displayControls?: boolean;
}

/**
 * Ce composant permet d'afficher la liste des média correspondant à ce profil
 */
export class MediaProfile extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            // Media: [],
            nouveauMedia: null,
            nom: '',
            description: '',
            listeevent: [],
            probleme: false,
            messageprobleme: '',
            redirect: false,
            mediaRedirect: 1,
        };
        // this.getMedia();
        // this.getEvent();
    }

    handleSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files !== null) {
            this.setState({ nouveauMedia: event.target.files[0] });
        }
    }
    handledescription = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ description: event.target.value });
    }

    render() {
        var footer: JSX.Element | undefined = undefined;
        if (this.props.displayControls !== false) {
            footer = (
                <div className="card-footer">
                    <h3 style={{ fontSize: '20px', marginBottom: '20px' }}>Ajouter un média</h3>
                    <div className="row" style={{ float: 'right', marginRight: '1cm' }}>
                        <input
                            type="text"
                            placeholder="Description du média"
                            onChange={this.handledescription}
                            style={this.state.probleme === false ? { marginRight: '20px' } :
                                { borderColor: 'red', marginRight: '20px' }}
                        />
                        <input
                            type="text"
                            placeholder="Nom"
                            style={{ marginRight: '20px' }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ nom: e.target.value });
                            }}
                        />
                        <input
                            type="file"
                            id="file"
                            onChange={this.handleSelectFile}
                            style={this.state.probleme === false ? { marginRight: '20px', paddingTop: '5px' } :
                                { borderColor: 'red', marginRight: '20px', paddingTop: '5px' }}
                        />
                        <LoaderButton
                            className="btn"
                            confirmation={true}
                            style={{ width: '3.5cm' }}
                            modalTitle="Ajout d'un média"
                            modalBody={'Etes-vous sur de vouloir ajouter ce média'}
                            disabled={
                                this.state.nom === '' ||
                                this.state.description === '' ||
                                this.state.nouveauMedia === null
                            }
                            onClick={
                                () => {
                                    if (this.state.description === '' ||
                                        this.state.nouveauMedia === null) {
                                        return Promise.reject('');
                                    } else {
                                        return MediaService.getInstance()
                                            .AjouterMedia(
                                                this.state.nouveauMedia,
                                                this.state.description,
                                                this.state.nom
                                            ).then(
                                                (elem: ReqType.Media) => {
                                                    this.props.media.push(elem);
                                                    this.props.setMedia(this.props.media);
                                                }
                                            );
                                    }
                                }
                            }
                        >
                            Valider
                        </LoaderButton>
                    </div>
                    <div className="form-group">
                        <label style={{ color: 'red' }}>{this.state.messageprobleme}</label>
                    </div>
                </div >
            );
        }
        if (this.state.redirect) {
            return <Redirect to={'/gestion-media/' + this.state.mediaRedirect} />;
        } else {
            const listitem = this.props.media.map(
                (element: ReqType.Media, index: number) => {
                    return this.getLine(element, index);
                }
            );
            return (
                <div className="card card-default">
                    <div className="card-header col-12">
                        <h4 className="text-white">
                            <strong>Mes Medias</strong>
                        </h4>
                    </div>
                    <div className="card-body" style={{ overflow: 'auto', maxHeight: '700px' }}>
                        <TableChorinitia
                            header={
                                <thead>
                                    <tr>
                                        <th style={{ width: '4cm' }} scope="col">Nom</th>
                                        <th style={{ width: '3cm' }} scope="col">Etat</th>
                                        <th scope="col">Lien (Photo ou Video)</th>
                                        <th scope="col">Voir</th>
                                        <th scope="col">Supprimer</th>
                                    </tr>
                                </thead>
                            }
                        >
                            <tbody>
                                {listitem}
                            </tbody>
                        </TableChorinitia>
                    </div>
                    {footer}
                </div>
            );
        }
    }

    private getEtat(media: ReqType.Media) {
        if (media.afficher === 1) {
            return (<td className="table-success">Visible</td>);
        } else {
            return (<td className="table-danger">Non Visible</td>);
        }
    }

    private getLine = (element: ReqType.Media, index: number) => {
        return (
            <tr
                key={element.id}
            >
                <td>{element.nom}</td>
                {this.getEtat(element)}
                <td>
                    {
                        element.type_media_id.toString() ===
                            ReqType.Type_Media.PHOTO.toString() ? (
                                <img
                                    className="col-8"
                                    src={
                                        MediaService.getInstance().getBaseURL() +
                                        element.lien
                                    }
                                />
                            ) : (
                                <video controls={true} className="col-12">
                                    <source
                                        src={
                                            MediaService.getInstance().getBaseURL() +
                                            element.lien
                                        }
                                        type="video/mp4"
                                    />
                                </video>
                            )
                    }
                </td>
                <td><Link to={'/gestion-media/' + element.id}>Lien</Link></td>
                <td>
                    <LoaderButton
                        className="btn badge-danger"
                        confirmation={true}
                        modalTitle="Suppression d'un média"
                        modalBody={
                            'Souhaitez-vous vraiment supprimer le ' +
                            element.nom +
                            '?'
                        }
                        onClick={
                            () => {
                                return MediaService.getInstance().
                                    supprimerMedia(this.props.media[index]).then(
                                        () => {
                                            this.props.media.splice(index, 1);
                                            this.props.setMedia(this.props.media);
                                        }
                                    );
                            }
                        }
                    >
                        <i className="fa fa-minus" />
                    </LoaderButton>
                </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/MediaProfile.tsx